<template>
<div>
  <FuelStore ref="fuelStore" />

  <div>
    <h3>Fuel Summary Report</h3>

    <GenericDatePeriodSelector storeName="fuelStore" />
    <GenericDaysSelector storeName="fuelStore" />
    <!-- <DateSelectorTest /> -->

    <h3>RCGB</h3>
    <PayAtPumpSummary location="RCGB" />
    <h3>RMGB</h3>
    <PayAtPumpSummary location="RMGB" />
    <h3>WGB</h3>
    <PayAtPumpSummary location="WGB" />
  </div>


</div>
</template>

<script>
import FuelStore from './Stores/FuelStore.vue'
import PayAtPumpSummary from './Components/PayAtPumpSummary.vue'
import formatDataMixin from '@/mixins/formatDataMixin.js'

export default {
  name: 'FuelSummaryReport',
  mixins : [formatDataMixin],
  components:{PayAtPumpSummary,         FuelStore},
    provide() {
    return {
      payAtPumpPage: this,
      page: this,
    }
  },
  computed:{
    // fuelStore(){ return this.$refs.fuelStore},
    timestamps(){ return this.$refs.fuelStore.timestamps},
  },

}
</script>

<style lang="scss" scoped>

</style>